import { render, staticRenderFns } from "./checkbox-filter.vue?vue&type=template&id=6f0c52b1&"
import script from "./checkbox-filter.vue?vue&type=script&lang=ts&"
export * from "./checkbox-filter.vue?vue&type=script&lang=ts&"
import style0 from "./checkbox-filter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports